<script setup lang="ts">
import draggable from 'vuedraggable'
import { StyleImagesDocument, type StyleImage } from '~/graphql/operations'

const props = defineProps({
  context: Object,
})

const availableList = ref([])
const selectedList = ref([])

useQuery({
  query: StyleImagesDocument,
  variables: {
    perPage: 100,
    where: {
      id: {
        notIn: props.context._value,
      },
    },
  },
}).then(
  ({ data }) => (availableList.value = data.value?.styleImages?.data || []),
)

useQuery({
  query: StyleImagesDocument,
  variables: {
    perPage: 100,
    where: {
      id: {
        in: props.context._value,
      },
    },
  },
}).then(
  ({ data }) => (selectedList.value = data.value?.styleImages?.data || []),
)

function handleInput() {
  props.context.node.input(selectedList.value.map((item) => item.id))
}
</script>

<template>
  <div class="grid grid-cols-2 gap-3 max-h-96 overflow-hidden">
    <div
      class="flex flex-col py-4 border rounded-lg bg-gray-50 shadow-sm overflow-hidden"
    >
      <h3 class="text-base font-medium px-4">Available</h3>
      <draggable
        v-model="availableList"
        class="list-group flex-grow space-y-1 mt-3 px-4 overflow-y-scroll"
        group="people"
        item-key="id"
      >
        <template
          #item="{ element, index }: { element: StyleImage, index: number }"
        >
          <div class="list-group-item border p-2 rounded-lg bg-white shadow-sm">
            <img
              :src="element.image.fileUrl"
              alt="image"
              class="w-full h-24 object-cover"
            />
          </div>
        </template>
      </draggable>
    </div>

    <div
      class="flex flex-col py-4 border rounded-lg bg-gray-50 shadow-sm overflow-hidden"
    >
      <h3 class="text-base font-medium px-4">Selected</h3>
      <draggable
        v-model="selectedList"
        class="list-group flex-grow space-y-1 mt-3 px-4 overflow-y-scroll"
        group="people"
        item-key="id"
        @change="handleInput"
      >
        <template
          #item="{ element, index }: { element: StyleImage, index: number }"
        >
          <div class="list-group-item border p-2 rounded-lg bg-white shadow-sm">
            <img
              :src="element.image.fileUrl"
              alt="image"
              class="w-full h-24 object-cover"
            />
          </div>
        </template>
      </draggable>
    </div>
  </div>
</template>
